import React, { useEffect, useRef, useState } from 'react';
import { NavLink } from "react-router-dom";
import bgMatreshki from '../../../asset/matreshka-bg.png'
import Button from "@material-ui/core/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useMediaQuery } from "@material-ui/core";
import DoubleArrowRoundedIcon from '@material-ui/icons/DoubleArrowRounded';


const SidebarMain = ({ mobile, handelLogout, percentObjects, sidebarRef, scrollSidebarRef }) => {

    return (
      <div ref={scrollSidebarRef} className="left-menu__scroll" style={{ backgroundImage: "url(" + bgMatreshki + ")" }}>
          <div ref={sidebarRef} className="sidenav-menu">
              <div className="sidenav-item">
                  <div className="sidenav-item__link sidenav-item__title">Кабинет отельера</div>
                  <div className="sidenav-item__link__collapse">

                      <NavLink exact activeClassName="active"
                               className="btn sidenav-item__link"
                               to="/lk">Мои объекты</NavLink>

                      <NavLink activeClassName="active"
                               className="btn sidenav-item__link "
                               to="/lk/booking">Бронирования</NavLink>

                      {percentObjects && Object.keys(percentObjects).length !== 0
                        ? <NavLink activeClassName="active"
                                   className="btn sidenav-item__link "
                                   to="/lk/busy-calendar">Календарь занятости</NavLink>
                        : null}

                      <NavLink activeClassName="active"
                               className="btn sidenav-item__link"
                               to="/lk/reviews">Отзывы</NavLink>

                      <NavLink activeClassName="active"
                               className="btn sidenav-item__link "
                               to="/lk/invoices">Счета</NavLink>

                      <NavLink activeClassName="active"
                               className="btn sidenav-item__link "
                               to="/lk/contracts">Договоры</NavLink>
                      <div className="sidenav-item">
                          <a target="_blank" className="btn sidenav-item__link"
                             href="https://edem-v-gosti.ru/help/dlya-otelerov/" rel="noreferrer">Помощь</a>
                      </div>
                      {/*TODO в разработке*/}
                      {/*<NavLink activeClassName="active"
                                 className="btn sidenav-item__link "
                                 to="/lk/access-right">Права доступа</NavLink>*/}
                      {mobile && <>
                          <NavLink activeClassName="active"
                                   className="btn sidenav-item__link "
                                   to="/lk/profile">Настройки аккаунта</NavLink>

                          <span className="btn sidenav-item__link "
                                onClick={handelLogout}
                          >Выход</span>
                      </>}


                  </div>
              </div>
              {/*TODO для личного кабинета туриста*/}
              {/*<div className="sidenav-item">
                    <NavLink className="btn sidenav-item__link" to="tourist">Мои
                        путешествия</NavLink>
                </div>*/}
          </div>

      </div>
    )
}

const SidebarObject = ({ objectId, objectActive, paymentType, mobile, handelLogout, userRole, sidebarRef, scrollSidebarRef }) => {

    return (
      <div ref={scrollSidebarRef} className="left-menu__scroll edit-object"
           style={{ backgroundImage: "url(" + bgMatreshki + ")" }}>
          <div ref={sidebarRef} className="sidenav-menu">
              <div className="sidenav-item backToObjects">
                  <Button component={NavLink} className="btn btn-outline-light" to="/lk">
                      <FontAwesomeIcon icon="arrow-left" className="me-1"/> Мои объекты</Button>
              </div>
              <div className="sidenav-item">
                  <NavLink exact activeClassName="active"
                           className="btn sidenav-item__link"
                           to={`/lk/${objectId}`}>Рабочий
                      стол</NavLink>
              </div>
              <div className="sidenav-item">
                  <NavLink exact activeClassName="active"
                           className="btn sidenav-item__link"
                           to={`/lk/${objectId}/bookings`}>Бронирования</NavLink>
              </div>

              <div className="sidenav-item">
                  <NavLink exact activeClassName="active"
                           className="btn sidenav-item__link"
                           to={`/lk/${objectId}/about`}>Описание</NavLink>
              </div>


              <div className="sidenav-item">
                  <NavLink exact activeClassName="active"
                           className="btn sidenav-item__link"
                           to={`/lk/${objectId}/stock`}>Акции и скидки</NavLink>
              </div>


              <div className="sidenav-item">
                  <NavLink exact activeClassName="active"
                           className="btn sidenav-item__link"
                           to={`/lk/${objectId}/photo`}>Фотографии</NavLink>

              </div>

              <div className="sidenav-item">
                  <NavLink exact activeClassName="active"
                           className="btn sidenav-item__link"
                           to={`/lk/${objectId}/distances`}>Расположение</NavLink>

              </div>

              <div className="sidenav-item">
                  <NavLink exact activeClassName="active"
                           className="btn sidenav-item__link"
                           to={`/lk/${objectId}/contacts`}>Контакты</NavLink>
              </div>

              <div className="sidenav-item">
                  <NavLink exact activeClassName="active"
                           className="btn sidenav-item__link"
                           to={`/lk/${objectId}/services`}>Услуги</NavLink>

              </div>
              <div className="sidenav-item">
                  <NavLink exact activeClassName="active"
                           className="btn sidenav-item__link"
                           to={`/lk/${objectId}/conditions`}>Правила проживания</NavLink>
              </div>
              <div className="sidenav-item">
                  <NavLink activeClassName="active"
                           className="btn sidenav-item__link"
                           to={`/lk/${objectId}/rooms`}>Номера</NavLink>
              </div>
              {paymentType === "percent" && <div className="sidenav-item">
                  <NavLink activeClassName="active"
                           className="btn sidenav-item__link"
                           to={`/lk/${objectId}/rate-plans`}>Тарифные планы</NavLink>
              </div>}

              <div className="sidenav-item">
                  <NavLink activeClassName="active"
                           className="btn sidenav-item__link"
                           to={`/lk/${objectId}/calendar`}>Цены</NavLink>
              </div>

              {paymentType === "percent" && <div className="sidenav-item">
                  <NavLink activeClassName="active"
                           className="btn sidenav-item__link"
                           to={`/lk/${objectId}/busy-calendar`}>Календарь занятости</NavLink>
              </div>}
              {
                  (paymentType === 'percent' || objectActive !== 'Y' || (userRole === 'MODERATOR' && paymentType === 'percent'))
                  && <div className="sidenav-item">
                      <NavLink activeClassName="active"
                               className="btn sidenav-item__link"
                               to={`/lk/${objectId}/channel-manager`}>Менеджер каналов</NavLink>
                  </div>
              }

              {userRole === "MODERATOR" && <div className="sidenav-item">
                  <NavLink activeClassName="active"
                           className="btn sidenav-item__link"
                           to={`/lk/${objectId}/history`}>История изменений</NavLink>
              </div>}

              <div className="sidenav-item">
                  <a target="_blank" className="btn sidenav-item__link"
                     href="https://edem-v-gosti.ru/help/dlya-otelerov/" rel="noreferrer">Помощь</a>
              </div>
              {mobile && <>
                  <div className="sidenav-item">
                      <NavLink activeClassName="active"
                               className="btn sidenav-item__link "
                               to="/lk/profile">Настройки аккаунта</NavLink>
                  </div>
                  <div className="sidenav-item">
                        <span className="btn sidenav-item__link "
                              onClick={handelLogout}
                        >Выход</span>
                  </div>
              </>}
          </div>

      </div>


    )
}

const Sidebar = (props) => {
    const {
        editObject,
        leftMenuActive,
        objectId,
        toggleLeftMenu,
        paymentType,
        logoutUser,
        percentObjects,
        userRole,
        objectActive
    } = props
    const mobile = useMediaQuery('(max-width: 575px)');
    const [showScrollHelper, setShowScrollHelper] = useState(false)

    let scrollSidebar = useRef(null)

    useEffect(() => {
        if (leftMenuActive) {
            toggleLeftMenu(false)
        }
    }, [props.location.pathname])


    const toggleLeftMenuHandler = () => {
        toggleLeftMenu(false)
    }


    const handelLogout = () => {
        logoutUser()
    }

    const getSidebarHeight = (height) => {
        if (scrollSidebar.current?.clientHeight - 80 - height < 0) {
            setShowScrollHelper(true)
        }
    }


    let sidebarRef = useRef()
    let scrollSidebarRef = useRef()


    useEffect(() => {
        if (sidebarRef.current) {
            getSidebarHeight(sidebarRef.current.clientHeight)
        }
    }, [sidebarRef.current?.clientHeight])


    const eventScroll = (e) => {
        if (scrollSidebarRef.current) {
            scrollSidebarRef.current.scrollTo({
                top: scrollSidebarRef.current.scrollTop + 200,
                behavior: 'smooth'
            })
        }
    }

    return (
      <nav>
          <div onClick={toggleLeftMenuHandler}
               className={`left_menu-backdrop ${leftMenuActive ? 'active' : ''}`}></div>


          <div id="left-menu" ref={scrollSidebar} className={leftMenuActive ? 'active' : ''}>
              {editObject
                ? <SidebarObject mobile={mobile}
                                 handelLogout={handelLogout}
                                 objectId={objectId}
                                 objectActive={objectActive}
                                 paymentType={paymentType}
                                 userRole={userRole}
                                 sidebarRef={sidebarRef}
                                 scrollSidebarRef={scrollSidebarRef}
                />
                : <SidebarMain mobile={mobile}
                               handelLogout={handelLogout}
                               percentObjects={percentObjects}
                               userRole={userRole}
                               sidebarRef={sidebarRef}
                               scrollSidebarRef={scrollSidebarRef}/>

              }
              {showScrollHelper && <div onClick={eventScroll} className="sidenav-scroll-btn">
                  <DoubleArrowRoundedIcon/>
              </div>}
          </div>

      </nav>
    );
}

export default Sidebar;
